<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Invitations"/>
      <mdb-card class="mb-4 text-left" v-if="errors.length>0">
        <mdb-card-header class="danger-color text-white">
          <h5>Errors</h5>
        </mdb-card-header>
        <mdb-card-body>
          <p :key="i" v-for="(e,i) in errors">
            {{e}}
          </p>
          <mdb-btn @click="clearErrors" icon="check" rounded size="sm">Ok</mdb-btn>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4 text-left" v-if="!bulkModal">
        <mdb-card-body>
          <div v-if="!currentGroup.approved" class="text-info small">
            Until your group is approved, you are limited to 10 invitations.
          </div>
          <mdb-input @keydown.native="handleKeyDown" placeholder="Enter email address" type="text" v-model="email"/>
          <mdb-btn :disabled="!email" @click="saveEmail" color="green" icon="envelope" rounded size="sm">Send</mdb-btn>
          <mdb-btn @click="showHelp=true" icon="question" rounded size="sm">Explain This</mdb-btn>
          <mdb-btn v-if="currentGroup.approved" @click="bulkModal=true" icon="list" rounded size="sm">I Have a List</mdb-btn>

        </mdb-card-body>
        <mdb-card-footer v-if="showHelp">
          <p>If you would like to invite someone to join, enter their email address. If they are already a member of
            {{settings.siteName}}, they will be joined to your group immediately. If not, they will get an email with an invitation to
            join your group. </p>
          <p v-if="currentGroup.approved">If you already have a list and don't want to type in each address here, click the "I have a list"
            button.</p>
          <mdb-btn @click="showHelp=false" icon="thumbs-up" rounded size="sm">Got it!</mdb-btn>
        </mdb-card-footer>
      </mdb-card>
      <mdb-tbl responsive striped v-if="invitations.length>0">
        <mdb-tbl-head class="secondary-color text-white">
          <tr>
            <th>E-Mail Address</th>
            <th>Invite Created</th>
            <th>Status</th>
            <th>Email Sent</th>
            <th></th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr :key="i" v-for="(invite,i) in invitations">
            <td>{{invite.email}}</td>
            <td>{{invite.createdDate}}</td>
            <td>{{invite.status}}</td>
            <td v-if="invite.emailSent">{{invite.emailSent}}</td>
            <td v-if="!invite.emailSent">Queued for delivery.</td>
            <td>
              <mdb-btn v-if="currentGroup.approved" @click="deleteInvite(invite)" color="danger"
                       type=""
                       floating icon="trash" size="sm" tag="a"/>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>

      <mdb-modal v-if="bulkModal" size="lg" @close="bulkModal=false" scrollable>
        <mdb-modal-header color="secondary-color text-white" :close="true">Bulk Invite</mdb-modal-header >
        <mdb-modal-body>
          <h4>Separate emails with a space or a blank line</h4>
          <h5 class="text-info">Example:  user1@example.com user2@example.com user3@example.com</h5>
          <mdb-input id="bulk-input-form" type="textarea" :rows="10" v-model="email" placeholder="Paste emails here."/>
          <mdb-btn color="success" icon="envelope" size="sm" rounded @click="saveEmail">Send</mdb-btn>
          <mdb-btn color="danger" icon="times-circle" size="sm" rounded @click="bulkModal=false">Cancel</mdb-btn>
        </mdb-modal-body>
      </mdb-modal>
      <yes-no-modal v-if="deleteModal" @yes="doDelete" @no="deleteModal=false"/>

    </div>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mapState} from 'vuex'
import bannerSmall from '../group/BannerSmall'

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import YesNoModal from "../common/YesNoModal";

export default {
    name: "group-invitations",
    order: 1,
    components: {
      mdbContainer,
      bannerSmall,
      mdbTbl, mdbTblHead, mdbTblBody, mdbBtn, mdbInput, mdbCard, mdbCardHeader, mdbCardBody, mdbCardFooter,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      YesNoModal
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup,
                         settings: state => state.settings
                       }),
    data() {
      return {
        invitations: [],
        email: null,
        showHelp: false,
        bulkModal: false,
        errors: [],
        deleteCandidate: null,
        deleteModal: false,
      }
    },
    mounted() {
      document.title = "Invitations"
      if (!this.currentGroup) {
        api.groupBasics(this.$route.params.id, "perm:Send Invites");
      }

      this.$store.dispatch("setExecuting", true)
      api.get("/member/invitations/" + this.$route.params.id).then(
        (results) => {
          this.invitations = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      clearErrors() {
        this.errors = []
      },
      handleKeyDown(e) {
        if (e.keyCode == 13) this.saveEmail()
      },
      deleteInvite(i) {
        this.deleteCandidate = i
        this.deleteModal = true
      },
      doDelete() {
        this.deleteModal = false
        api.delete("/member/deleteInvite/" + this.deleteCandidate.id).then(
          (results) => {
            let loc = this.invitations.indexOf(this.deleteCandidate)
            this.invitations.splice(loc,1)
            this.deleteCandidate = null
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      saveEmail() {
        let emails =  this.email.replace( /\n/g, " " ).split( " " )
        if (this.invitations.length >= 10 && !this.currentGroup.approved) {
          this.$notify.error({message: "Maximum invitations reached for an unapproved group.", timeOut: 10000})
          return
        }
        this.bulkModal=false
        this.$store.dispatch("setExecuting", true)
        api.post("/member/sendInvitations/" + this.$route.params.id, {emails: emails}).then(
          (results) => {
            for (let i = 0; i < results.data.invites.length; i++) {
              this.invitations.unshift(results.data.invites[i])
            }
            this.errors = results.data.errors
            this.email = null
          },
          (error) => {
            if (emails.length > 1) this.bulkModal = true
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }
  };

</script>

